import PropTypes from 'prop-types';
import React from 'react';
import './TypingIndicator.scss';

// Decorative dots with no text: in the chat, the tutor's turn is announced by Chatbot's status region.
function TypingIndicator({ className = '', inline = false }) {
  return (
    <div className={`typing-indicator ${inline ? 'typing-indicator--inline' : ''} ${className || ''}`} aria-hidden="true">
      <span></span>
      <span></span>
      <span></span>
    </div>
  );
}

TypingIndicator.propTypes = {
  className: PropTypes.string,
  inline: PropTypes.bool,
};

export default TypingIndicator;
